import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/catalog";
import SocialButtons from "@/components/shop/SocialButtons";

const scrollToCatalog = (e) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo("#catalogo", { offset: -40 });
  else document.getElementById("catalogo")?.scrollIntoView({ behavior: "smooth" });
};

const Navbar = () => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#050505]/60 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
      <a href="#top" className="flex items-center gap-3" data-testid="navbar-logo-link">
        <img
          src="/assets/grandline-logo.jpg"
          alt="Grand Line Cards"
          className="h-11 w-11 rounded-full object-cover ring-1 ring-[#cba153]/60"
        />
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/80">
          Grandlinecards
        </span>
      </a>
      <nav className="flex items-center gap-4 md:gap-6">
        <div className="hidden items-center gap-3 sm:flex">
          <SocialButtons testIdPrefix="navbar" />
        </div>
        <a
          href="#catalogo"
          onClick={scrollToCatalog}
          data-testid="navbar-catalog-link"
          className="hidden font-mono text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-[#cba153] sm:block"
        >
          Catalogo
        </a>
        <a
          href={waLink("Ciao! Vorrei informazioni sulle carte disponibili.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="navbar-whatsapp-button"
          className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-105"
        >
          <MessageCircle size={14} strokeWidth={2.5} />
          WhatsApp
        </a>
      </nav>
    </div>
  </header>
);

export default Navbar;
